/** Get Dashboard */
export const GET_CARD_VALUE_SUCCESS = "GET_CARD_VALUE_SUCCESS"
export const GET_CARD_VALUE_ERROR = "GET_CARD_VALUE_ERROR"

export const GET_CHART_DATA_SUCCESS = 'GET_CHART_DATA_SUCCESS'
export const GET_CHART_DATA_ERROR = 'GET_CHART_DATA_ERROR'
